// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-radio-button_size-s {
  height: 24px;
}
.conn-form-radio-button_size-m {
  height: 28px;
}
.conn-form-radio-button_size-l {
  height: 36px;
}
.conn-form-radio-button_size-xl {
  height: 44px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/RadioButton/RadioButton.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AAGI;EACI,YAAA;AADR;AAII;EACI,YAAA;AAFR;AAKI;EACI,YAAA;AAHR","sourcesContent":[".conn-form-radio-button_size-s {\n  height: 24px;\n}\n.conn-form-radio-button_size-m {\n  height: 28px;\n}\n.conn-form-radio-button_size-l {\n  height: 36px;\n}\n.conn-form-radio-button_size-xl {\n  height: 44px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
